import { render, staticRenderFns } from "./RouterLink.vue?vue&type=template&id=492c7f2a&"
import script from "./RouterLink.vue?vue&type=script&lang=js&"
export * from "./RouterLink.vue?vue&type=script&lang=js&"
import style0 from "./RouterLink.vue?vue&type=style&index=0&id=492c7f2a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports